import React from 'react';
import Slider from 'react-slick';
import DidYouKnowCard from './DidYouKnowCard';
import './style.scss';

const DidYouKnow = ({ sectionData }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 7.2,
    slidesToScroll: 4,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const shouldDisplayArrow = sectionData?.cards?.length > 7;
  return (
    <div className="did-you-know-section">
      <div className="did-you-know-header-wrapper">
        <div className="did-you-know-header">
          <p className="heading">{sectionData?.header}</p>
          <p className="sub-heading">{sectionData?.subHeader}</p>
        </div>
        {shouldDisplayArrow && (
          <span className="slideArrow pushRight hideControls">
            <span className="lineSpacing">|</span>
          </span>
        )}
      </div>
      {!!sectionData?.cards?.length && (
        <div className="did-you-know-slider">
          <Slider {...settings}>
            {sectionData?.cards?.map((packageDetails, index) => (
              <DidYouKnowCard
                cardData={packageDetails}
                sectionIndex={sectionData?.order}
                cardIndex={index}
                key={packageDetails?.packageId}
                sectionCode={sectionData?.sectionCode}
                sectionOrder={sectionData?.order}
                sectionId={sectionData?.id}
                sectionHeader={sectionData?.header}
              />
            ))}
          </Slider>
        </div>
      )}
    </div>
  );
};

export default DidYouKnow;
